import { gql } from "@apollo/client";import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import CheckIcon from '@mui/icons-material/Check';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadIcon from '@mui/icons-material/Download';
import toast, { Toaster } from 'react-hot-toast';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DocumentViewer from '../../../components/DocumentViewer';
import { APPCONFIG } from '../../../app.config';
import ErrorDialog from '../../../components/ErrorDialog';
import { CircularProgress } from "@mui/material";
import fileDownload from 'js-file-download';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { WidthFull } from '@mui/icons-material';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function Referenciados() {

  const RESULTADO_VALIDACION_OK = 'OK';
  const COLOR_OK = 'green';
  const COLOR_ERROR = 'red';

  const [result, setResult] = useState('');
  const [data, setData] = useState([]);
  const [colorMsg, setCologMsg] = useState('');
  const [disabledBtnValidar, setDisabledBtnValidar] = useState(false);
  const [showGrilla, setShowGrilla] = useState(false);
  const [accion, setAccion] = useState('');


  // upload
  const [fileSelected, setFileSelected] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);

  // dlg visualización
  const [filePreview, setFilePreview] = useState([]);
  const [openDlg, setOpenDlg] = useState(false);

  // dlg confimración
  const [openDlgConfirm, setOpenDlgConfirm] = useState(false);

  // Log de errores
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
    clickClear();
  };

  let toastId = 0;
  const textInputConformidad = useRef(null);

  const Input = styled('input')({
    display: 'none'
  });

  const [formValues, setFormValues] = useState({
    Conformidad: ''
  });

  useEffect(() => {
    textInputConformidad.current.focus();
  }, []);

  const handleBlurConformidad = () => {
    if (formValues.Conformidad !== "") {
      setFormValues({
        Conformidad: String(formValues.Conformidad).padStart(10, "0")
      });
    }
  };

  const handleChangeConformidad = (event) => {
    const { value } = event.target;
    const regex = new RegExp("[0-9]+$");
    if (regex.test(value)) {
      setFormValues({
        Conformidad: value
      });
    } else if (value === '') {
      setFormValues({
        Conformidad: ''
      });
    }
  };

  const QExisteConformidad = gql`
        query QExisteConformidad ($conformidad: Int!) {
            existeConformidad 
            (
                conformidad: $conformidad
            ) 
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [getExisteConformidad, { data: dataExisteConformidad, error: errorExisteConformidad }] = useLazyQuery(QExisteConformidad, {
    fetchPolicy: 'no-cache'
  });


   useEffect(() => {
    if (!dataExisteConformidad) return;
    if (dataExisteConformidad.existeConformidad.success) {
      const valor = dataExisteConformidad.existeConformidad.valorEsperado;
      setResult(valor);
      if (valor === RESULTADO_VALIDACION_OK) {
        setDisabledBtnValidar(true);
        setCologMsg(COLOR_OK);
        // cargo si tiene un archivo ya asociado
        getDocumentoAsociado(parseInt(formValues.Conformidad, 10));
      } else {
        setCologMsg(COLOR_ERROR);
        // limpio la grilla
        setData([]);
      }
    } else {
      setMensajeError(dataExisteConformidad.existeConformidad.error);
    }
  }, [dataExisteConformidad]); 

  useEffect(() => {
    if (!errorExisteConformidad) return;
    setMensajeError("ERRORDB");
  }, [errorExisteConformidad]);


  const existeConformidad = (conformidad) => {
    getExisteConformidad({ variables: { conformidad: parseInt(conformidad, 10), idConsulta: Math.random() } });
  };

  const isValid = () => {
    let resultado = true;
    let mensaje = RESULTADO_VALIDACION_OK;

    // Formulario
    if (formValues.Conformidad === "") {
      return {
        resultado: false,
        mensaje: "El Número de Conformidad es obligatorio."
      };
    }

    return { success: resultado, mensaje: mensaje };
  };

  const clickCheck = () => {
    const validacion = isValid();
    if (validacion.success) {
      existeConformidad(formValues.Conformidad);
    } else {
      setResult(validacion.mensaje);
      setCologMsg(COLOR_ERROR);
    }
  };

  const clickClear = () => {
    setFormValues({
      Conformidad: ''
    });
    textInputConformidad.current.focus();
    setResult("");
    setDisabledBtnValidar(false);
    setShowGrilla(false);
  };

  // INICIO - DOCUMENTO ASOCIADO 

  const QGetArchivo = gql`
        query QGetArchivo ($conformidad: Int!) {
            archivoConformidad
            (
                conformidad: $conformidad
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivoConformidades,
                    nroConformidad,
                    fechaAlta,
                    titulo,
                    contentType,
                    extension,
                    archivo
                } 
            }
        }`;

  const [getArchivoQuery, { data: dataFile, error: errorFile }] = useLazyQuery(QGetArchivo, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataFile) return;
    toast.dismiss(toastId);
    if (dataFile.archivoConformidad.success) {
      setShowGrilla(true);
      if (accion === 'VIEW') {
        setFilePreview(dataFile.archivoConformidad.valorEsperado[0]);
        setOpenDlg(true);
      }

      if (accion === 'DOWNLOAD') {
        const arr = new Uint8Array(dataFile.archivoConformidad.valorEsperado[0].archivo);
        const documento = new Blob([arr], { type: dataFile.archivoConformidad.valorEsperado[0].contentType });
        const fileName = dataFile.archivoConformidad.valorEsperado[0].titulo + dataFile.archivoConformidad.valorEsperado[0].extension;

        fileDownload(documento, fileName);
      }

      if (accion === 'BORRAR') {
        setOpenDlgConfirm(true);
      }
    } else
    {
      setMensajeError(dataFile.archivoConformidad.error);
    };
  }, [dataFile]);

  useEffect(() => {
    if (!errorFile) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorFile]);

  const QGetTituloArchivoConformidad = gql`
        query QGetTituloArchivoConformidad ($conformidad: Int!) {
            tituloArchivoConformidad
            (
                conformidad: $conformidad
            ) 
            {
                success,
                error,
                valorEsperado {
                    idArchivoConformidades,
                    nroConformidad,
                    fechaAlta,
                    titulo,
                    contentType,
                    extension
                } 
            }
        }`;

  const [getDocumentoAsociadoQuery, { data: dataArchivo, error: errorArchivo }] = useLazyQuery(QGetTituloArchivoConformidad, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataArchivo) return;
    toast.dismiss(toastId);
    if (dataArchivo.tituloArchivoConformidad.success) {
      setShowGrilla(true);
      setData(dataArchivo.tituloArchivoConformidad.valorEsperado);
    } else
    {
      setMensajeError(dataArchivo.tituloArchivoConformidad.error);
    };
  }, [dataArchivo]);


  useEffect(() => {
    if (!errorArchivo) return;
    toast.dismiss(toastId);
    setMensajeError("ERRORDB");
  }, [errorArchivo]);


  const getDocumentoAsociado = (conformidad) => {
    setData([]);
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    getDocumentoAsociadoQuery({ variables: { conformidad: conformidad } });
  };

  const getArchivo = (conformidad) => {
    //getArchivoQuery({ variables: { conformidad: conformidad } });
    getArchivoQuery({ variables: { conformidad: parseInt(conformidad, 10) } });

  };
  // FIN - DOCUMENTO ASOCIADO

  // INICIO - SUBIR DOCUMENTO

  const MSubirDocumentoConformidad = gql`
        mutation MSubirDocumentoConformidad (
            $conformidad: Int!, $contentType: String!, $titulo: String!, $archivo: [Byte!]!, $extension: String!) {
            subirDocumentoConformidad 
            (
                conformidad: $conformidad,
                contentType: $contentType,
                titulo: $titulo,
                archivo: $archivo,
                extension: $extension,
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [subirDocumento, { data: dataSubirDocumento }] = useMutation(MSubirDocumentoConformidad, {
    onCompleted: (dataSubirDocumento) => {
      if (dataSubirDocumento.subirDocumentoConformidad.success) {
        if (dataSubirDocumento.subirDocumentoConformidad.valorEsperado) {
          getDocumentoAsociado(parseInt(formValues.Conformidad, 10));
        } else {
          setShowGrilla(true); 
          toast.error(dataSubirDocumento.subirDocumentoConformidad.error);
        }
      } else {
        toast.dismiss(toastId);
        setShowGrilla(true); 
        setMensajeError(dataSubirDocumento.subirDocumentoConformidad.error);
      }
    },
    onError: (dataSubirDocumento) => {
      toast.dismiss(toastId);
      setMensajeError("ERRORDB");
    }
  });

  const handleChangeFile = (event) => {
    //toastId = toast.loading('Cargando...', { id: 'clipboard' });
    setShowGrilla(false);
    setFileSelected(event.target.files[0]);
    setIsFilePicked(true);
  };

  const isValidTipoArchivoAdjunto = () => {
    let sizeFile = fileSelected.size;
    if (sizeFile > APPCONFIG.SIZEARCHIVO.CONFORMIDAD.SIZE)
    return -1;

    return APPCONFIG.TIPOADJUNTO.CONFORMIDAD.some((e) => e === fileSelected.type);
  };

  useEffect(() => {
    if (isFilePicked) {
      let isValido = isValidTipoArchivoAdjunto();
      if (isValido > 0) {
        const reader = new FileReader();
        const fileByteArray = [];
        reader.readAsArrayBuffer(fileSelected);
        reader.onloadend = (evt) => {
          if (evt.target.readyState === FileReader.DONE) {
            const arrayBuffer = evt.target.result,
              array = new Uint8Array(arrayBuffer);
            for (const a of array) {
              fileByteArray.push(a);
            }

            subirDocumento({
              variables: {
                conformidad: parseInt(formValues.Conformidad, 10),
                titulo: String(formValues.Conformidad).padStart(10, "0"),
                contentType: fileSelected.type,
                extension: "." + fileSelected.name.split(".")[1],
                archivo: fileByteArray
              }
            });
          }
        };
      } else {
        setShowGrilla(true);
        isValido == 0 ? toast.error("El tipo de archivo adjunto no está permitido.") :
        toast.error("El tamaño del archivo adjunto no está permitido, su máximo permitido es: " + APPCONFIG.SIZEARCHIVO.CONFORMIDAD.INFO);
      }
      setIsFilePicked(false);
    }
  }, [isFilePicked]);

  // FIN - SUBIR DOCUMENTO

  // INICIO - ELIMINAR DOCUMENTO

  const handleAceptarEliminar = () => {
    setOpenDlgConfirm(false);
    borrarDocumento({ variables: { conformidad: parseInt(formValues.Conformidad, 10) } });
  };

  const handleCancelarEliminar = () => {
    setOpenDlgConfirm(false);
  };

  const MBorrarArchivoConformidad = gql`
        mutation MBorrarArchivoConformidad ($conformidad: Int!) {
            borrarArchivoConformidad 
            (
                conformidad: $conformidad
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [borrarDocumento, { data: dataBorrarDocumento }] = useMutation(MBorrarArchivoConformidad, {
    onCompleted: (dataBorrarDocumento) => {
      if (dataBorrarDocumento.borrarArchivoConformidad.success) {
        // se eliminó el documento
        if (dataBorrarDocumento.borrarArchivoConformidad.valorEsperado) {
          // se debería volver a consultar los documentos, pero se sabe que
          // solo puede haber como máximo 1 documento, por lo tanto para no volver
          // a consultar a la base sin sentido directamente seteamos los datos para la grilla en null
          setData([]);
        } else {
          toast.error(dataBorrarDocumento.borrarArchivoConformidad.error);
        }
      } else {
        setMensajeError(dataBorrarDocumento.borrarArchivoConformidad.error);

      }
    },
    onError: (dataBorrarDocumento) => {
      setMensajeError("ERRORDB");
    }
  });

  const handleBorrar = () => {
    setShowGrilla(false);
    setAccion('BORRAR');
    getArchivo(formValues.Conformidad);
  };

  // FIN - ELIMINAR DOCUMENTO

  const handleView = (row) => {
    setShowGrilla(false);
    setAccion('VIEW');
    getArchivo(formValues.Conformidad);
  };

  const linkDescarga = (row) => {
    setShowGrilla(false);
    setAccion('DOWNLOAD');
    getArchivo(formValues.Conformidad);
  };

  const initialColumns = [
  {
    field: 'idArchivoConformidades',
    headerName: 'Id'
  },
  {
    field: 'titulo',
    headerName: 'Nombre'
  },
  {
    field: 'fechaAlta',
    headerName: 'Fecha'
  },
  {
    field: 'actions', headerName: 'Acciones', sortable: false,
    renderCell: (params) =>
    <>
                    <VisibilityIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
        onClick={() => handleView()}
        titleAccess='Visualizar' />
                    <DeleteOutlineIcon
        sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px' }}
        onClick={() => handleBorrar()}
        titleAccess='Borrar' />
                    <button onClick={() => linkDescarga()} style={{ border: 'none', background: 'none' }}>
                        <DownloadIcon
          sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt', marginLeft: '15px', paddingTop: '5px' }}
          titleAccess='Descargar' />
                    </button>
                </>

  }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  return (
    <>
            <FormControl variant="outlined" sx={{ display: 'block', alignItems: 'center' }} fullWidth>
                <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center">
                    <div className="documento-encabezado" style={{ color: '#0063BE' }}>Conformidad</div>
                    <div>
                        <TextField
              className="input-40"
              id="outlined-basic"
              inputRef={textInputConformidad}
              label="Nro. Conformidad"
              name="Conformidad"
              onBlur={handleBlurConformidad}
              onChange={handleChangeConformidad}
              required
              size="small"
              type="text"
              value={formValues.Conformidad}
              variant="outlined" />
            
                    </div>

                    <br />
                    <div>
                        <CustomButton disabled={disabledBtnValidar} variant="contained" endIcon={<CheckIcon />} onClick={clickCheck}>
                            Validar
                        </CustomButton>&nbsp;&nbsp;
                        <Button variant="contained" endIcon={<CloseIcon />} onClick={clickClear}>
                            Cancelar
                        </Button>
                    </div>

                    <br />

                    <div style={{ display: 'flex', fontSize: '11pt', textAlign: 'center' }}>
                        <label style={{ fontWeight: 'bold', color: '#818181' }}>Resultado: </label>&nbsp;
                        <label id="lblResult" style={{ color: colorMsg }}>{result}</label>
                    </div>

                    {showGrilla &&
          <>
                            <label htmlFor="icon-button-file">
                                <Input accept="image/jpeg,image/jpg,image/jfif,image/png,application/pdf" onChange={handleChangeFile} id="icon-button-file" type="file" />
                                <IconButton color="primary" aria-label="upload picture" component="span" size='large'>
                                    <CloudUploadIcon fontSize="inherit" />
                                </IconButton>
                            </label>
                            <div style={{ width: '100%' }}>
                                <DataGridGenerico
                columns={columns}
                id="DataRef"
                rows={data}
                toolbar={false} />
              
                            </div>
                        </>
          }

                    {result === RESULTADO_VALIDACION_OK && !showGrilla &&
          <div class="loadingFullPage">
                            <div><CircularProgress disableShrink /><br />Cargando...</div>
                        </div>
          }


                </Grid>
            </FormControl>

            {openDlg && <DocumentViewer data={filePreview} setOpenDlg={setOpenDlg} />}

            <CustomDialog
        maxWidth="md"
        open={openDlgConfirm}
        title='Documento asociado'
        onCancel={handleCancelarEliminar}
        onAccept={handleAceptarEliminar}>
        
                ¿<strong>Está seguro de eliminar</strong> el documento seleccionado?.
            </CustomDialog>
            <ErrorDialog
        id="dlg-error-conformidades"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);

}